module.exports = __webpack_public_path__ + "img/img1.f8f9e663.jpg";